<template>
  <div class="container" :style="`background-image:url(${bg})`">
    <div class="km button" @click="goVideoPlay('开幕式')">
      <img :src="videoicon" alt="" /> <span>开幕式</span>
    </div>
    <div class="qy button" @click="goVideoList('Enterprise')">
      <img :src="videoicon" alt="" /> <span>参展企业</span>
    </div>
    <div class="zt button" @click="goVideoList('ThemeDay')">
      <img :src="videoicon" alt="" /> <span>主题日</span>
    </div>
    <div class="qj button" @click="goVideoList('VR')">
      <img :src="linkicon" alt="" /> <span>全景VR</span>
    </div>
  </div>
</template>

<script>
import bg from "../assets/image/mbgbase64";
import linkicon from "../assets/icon/网络.png";
import videoicon from "../assets/icon/视频.png";
export default {
  name: "MnavPage",
  data() {
    return {
      bg,
      linkicon,
      videoicon,
    };
  },
  methods: {
    goVideoPlay(name) {
      sessionStorage.setItem("videoName", name + ".mp4");
      this.$router.push("videoplay");
    },
    goVideoList(name) {
      if (
        name === "ThemeDay" &&
        +new Date().getTime() < new Date("2022/09/06").getTime()
      ) {
        alert("主题日将于2022年9月6日开放，敬请期待");
        return;
      }
      sessionStorage.setItem("classification", name);
      // this.$router.push("/mlist");
      if (name === "Enterprise") {
        this.$router.push("/mlist");
      } else if (name === "ThemeDay") {
        this.$router.push("/mmlist");
      } else {
        this.$router.push("mmlist");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: cover;
}
.km {
  top: 80vh;
  left: 8.44667vw;
}
.qy {
  top: 80vh;
  left: 54.22334vw;
}
.zt {
  top: 90vh;
  left: 8.44667vw;
}
.qj {
  top: 90vh;
  left: 54.22334vw;
}
.button {
  position: absolute;
  width: 37.33vw;
  height: 10.667vw;
  line-height: 0px;
  text-align: center;
  color: #0083d4;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
  img {
    display: inline-block;
    width: 25px;
    height: 25px;
    vertical-align: middle;
  }
  span {
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
    vertical-align: middle;
  }
}
</style>